// extracted by mini-css-extract-plugin
module.exports = {"subjectsBackground":"topic-module--subjectsBackground--HVS7K"};